var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 181,
    viewBox: "0 0 180 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4694 15.1191H119.363L149.612 31.1082L149.609 31.111L174.184 68.3816L174.188 68.3828L174.193 68.3798L174.19 68.3837L174.194 68.3852L174.184 68.3902L89.9181 165.874L89.9146 165.882L89.9085 165.867L5.64689 68.3893L5.63968 68.3857L5.63867 68.386L5.6391 68.3854L5.63867 68.3852L5.63942 68.3849L5.64099 68.3825L5.63867 68.3798L5.64174 68.3814L30.2199 31.1064L30.2214 31.108L60.4694 15.1191ZM130.572 52.8632L117.806 96.9533L117.805 96.9539L130.571 52.8629L130.571 52.8629L130.572 52.8632ZM89.9185 61.5249L117.801 96.9584L117.8 96.9616L89.9154 61.5258L89.9158 61.5253L89.9163 61.5254L89.9185 61.5249ZM62.0275 96.9539L62.0293 96.9548L62.031 96.9591L62.0315 96.9586L49.2641 52.8634L49.2616 52.8629L49.2612 52.8624L62.0275 96.9539Z",
    fill: "url(#paint0_linear_3293_26448)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.63867 68.3871L30.2199 31.1074L49.2605 52.8621L5.63867 68.3871Z",
    fill: "#F3ECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.0293 96.9613L5.63867 68.3863L49.2605 52.8613L62.0293 96.9613Z",
    fill: "#B791FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9184 61.5238L49.2637 52.8613L62.0324 96.9613L89.9184 61.5238Z",
    fill: "#9762FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.187 68.3871L149.606 31.1074L130.565 52.8621L174.187 68.3871Z",
    fill: "#8242FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.804 96.9613L174.194 68.3863L130.572 52.8613L117.804 96.9613Z",
    fill: "#B791FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.917 61.5238L130.572 52.8613L117.803 96.9613L89.917 61.5238Z",
    fill: "#F3ECFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.8 96.9629L89.9143 61.5254L62.0283 96.9629H117.8Z",
    fill: "#B791FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.4691 15.1191H119.363L149.611 31.1082L130.571 52.8629L89.916 61.5254L49.2613 52.8629L30.2207 31.1082L60.4691 15.1191Z",
    fill: "#CCB2FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9152 165.876L5.63867 68.3809L62.0293 96.9559L89.9152 165.876Z",
    fill: "#8242FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.917 165.876L174.194 68.3809L117.803 96.9559L89.917 165.876Z",
    fill: "#CCB2FE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M117.8 96.9629L89.9143 165.883L62.0283 96.9629H117.8Z",
    fill: "#F3ECFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3293_26448",
    x1: 11.6688,
    y1: 76.4465,
    x2: 184.483,
    y2: 78.6474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01365,
    stopColor: "#49BEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267502,
    stopColor: "#6188FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711858,
    stopColor: "#8140FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.30effea5b785ed7698d59a033e5cf38d.svg";
export { ForwardRef as ReactComponent };